/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProductSelectionRequest = {
    /**
     * Name of the product
     */
    product_name: string;
    /**
     * Quadrant where the product is placed
     */
    quadrant: ProductSelectionRequest.quadrant;
};
export namespace ProductSelectionRequest {
    /**
     * Quadrant where the product is placed
     */
    export enum quadrant {
        TOP_LEFT = 'top_left',
        TOP_RIGHT = 'top_right',
        BOTTOM_LEFT = 'bottom_left',
        BOTTOM_RIGHT = 'bottom_right',
    }
}

